const isValidType = (type) => (['day', 'week', 'month'].includes(type));

export default isValidType;
